import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function InsightsIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" fill="none" viewBox="0 0 40 40" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M24.515 6.869c-.092-.27-.605-.27-.696 0-.264.776-.683 1.736-1.282 2.335-.598.598-1.559 1.018-2.335 1.281-.27.092-.27.605 0 .696.776.264 1.736.683 2.335 1.282s1.018 1.559 1.282 2.335c.091.27.604.27.696 0 .263-.776.683-1.736 1.281-2.335.599-.599 1.559-1.018 2.335-1.282.27-.091.27-.604 0-.696-.776-.263-1.736-.683-2.335-1.281-.598-.599-1.018-1.559-1.281-2.335ZM6.667 33.333a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666ZM15 21.667A3.333 3.333 0 1 0 15 15a3.333 3.333 0 0 0 0 6.667ZM25 30a3.333 3.333 0 1 0 0-6.667A3.333 3.333 0 0 0 25 30Z"
      />
      <Box as="path" stroke="currentColor" strokeWidth="3.333" d="M6.667 30 15 18.333l10 8.334 8.333-10" />
      <Box
        as="path"
        fill="currentColor"
        d="M33.333 20a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM7.5 16.667a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
    </Icon>
  );
}
